/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadybadgetext3Inputs */

const en_searchreadybadgetext3 = /** @type {(inputs: Searchreadybadgetext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add the button to your website. The link to Pulsify helps Google and AI search find you.`)
};

const de_searchreadybadgetext3 = /** @type {(inputs: Searchreadybadgetext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füg den Button auf deiner Website ein. Der Link zu Pulsify hilft Google und KI-Suchen, dich zu finden.`)
};

/**
* | output |
* | --- |
* | "Add the button to your website. The link to Pulsify helps Google and AI search find you." |
*
* @param {Searchreadybadgetext3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadybadgetext3 = /** @type {((inputs?: Searchreadybadgetext3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadybadgetext3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadybadgetext3(inputs)
	return de_searchreadybadgetext3(inputs)
});
export { searchreadybadgetext3 as "searchReadyBadgeText" }